import { layout } from 'app_previous/styles/layout';
import styled from 'styled-components';

interface RowContainerProps {
  templateColumns: string;
  columnCount: number;
}

export const RowContainer = styled.tr<RowContainerProps>`
  display: grid;
  grid-template-columns: ${({ templateColumns }) => templateColumns};

  @media all and (max-width: ${layout.md}) {
    display: grid;
    width: 100%;
    box-sizing: border-box;

    grid-template-columns: repeat(${(props) => props.columnCount - 1}, 1fr);
    grid-template-rows: repeat(2, auto);

    .title-cell {
      grid-area: 1 / 1 / 2 / ${(props) => props.columnCount};
    }
  }
`;
